module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/icon_check_647abff374e5604e7395c742a908b87b.png";